import React from 'react';
import { ProviderParams } from '../models/react';
import { ToggleContextType } from '../models/toggle';
import { useEngagementContext } from './engagement';
import useSessionStorage, { sessionStorageHook } from '../hooks/sessionStorage.hook';
import { SDKEngagementStatus } from '../models/sdk';

const ToggleContext = React.createContext<ToggleContextType | undefined>(undefined);
export function useToggleContext() {
    return React.useContext(ToggleContext);
}


export default function ToggleProvider({ children }: ProviderParams) {

    const toggleStorage: sessionStorageHook = useSessionStorage("toggle")
    const [isOpen, setIsOpen] = React.useState(toggleStorage.value==="true");
    const [isLoading, setIsLoading] = React.useState(false);
    const [counter, setCounter] = React.useState(0);
    const engagementCtxt = useEngagementContext();
    const onClick = () => {
        if (!isLoading && !isOpen && counter === 0) {
            setCounter(counter+1);
            if (engagementCtxt && !engagementCtxt?.isConnected()){
                setIsLoading(true);
            }
        }
        setIsOpen(state => !state);
        toggleStorage.setValue(`${!isOpen}`)

    }
    
    const stopLoading = () => {
        setIsLoading(false)
    }
    const resetCounterToggle = () => {
        setCounter(0);
    }
    return (
        <ToggleContext.Provider value={{ isOpen, isLoading, onClick, stopLoading, resetCounterToggle }}>
            {children}
        </ToggleContext.Provider>
    );
}
